import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import About from './pages/About';
import Home from './pages/Home';
import Page404 from './pages/Page404';
import Stocks from './pages/Stocks';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/stocks" element={<Stocks />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );

};

export default App;
